export const NotificationContainer = ({ children }) => {
    return (
      <div style={{
        position: "fixed",
        top: "60px",
        right: "16px",
        zIndex: 1000,
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        alignItems: "flex-end",
      }}>
        {children}
      </div>
    );
};